module.exports = __webpack_public_path__ + "img/chinesecompany84.0b0ade6c.png";